const sessionStorageKeys = {
  FOCUSED_DATE_KEY: "focusedDate",
  ALL_SESSIONS_ELECTRONIC_SIGNATURE_KEY: "allSessionsElectronicSignature",
  NON_SCHOOL_DAYS: "nonSchoolDays",
  NORTH_PASS_KEY: "northPass",
  CAMPUS_MODAL_DISMISSED_KEY: "xng_campus_selection_dismissed",
  MSB_CLAIM_EXPLORER_FILTERS: "msbClaimExplorerFilters",
} as const;

export type XNGSessionStorageKey = (typeof sessionStorageKeys)[keyof typeof sessionStorageKeys];

export default sessionStorageKeys;
